import { useState } from "react";
const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  className = "",
  ...props
}) => {
  const [internalChecked, setInternalChecked] = useState(checked);

  // If controlled, use checked prop, otherwise use internal state
  const isControlled = typeof checked === "boolean" && typeof onChange === "function";
  const value = isControlled ? checked : internalChecked;

  const handleClick = (e) => {
    e.preventDefault();
    if (disabled) return;
    if (isControlled) {
      onChange(!checked, e);
    } else {
      setInternalChecked((prev) => {
        if (onChange) onChange(!prev, e);
        return !prev;
      });
    }
  };

  return (
    <button
      type="button"
      className={
        "flex h-8 w-14 items-center rounded-full p-1 ring-1 ring-inset transition-colors duration-200 ease-in-out " +
        (value
          ? "bg-amber-500 ring-black/20 dark:bg-amber-600 dark:ring-black/20"
          : "bg-stone-300 ring-stone-900/5 dark:bg-slate-700 dark:ring-stone-900/5") +
        (disabled ? " opacity-50 cursor-not-allowed" : " cursor-pointer") +
        (className ? " " + className : "")
      }
      aria-pressed={value}
      aria-disabled={disabled}
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
      {...props}
    >
      <span
        className={
          "inline-block h-6 w-6 transform rounded-full bg-white shadow-sm ring-1 ring-stone-700/10 transition duration-200 ease-in-out " +
          (value ? "translate-x-6" : "")
        }
      ></span>
    </button>
  );
};

export default Switch;
